require.register("app/supplier/show/InfoTab", function(exports, require, module){
  $0
  
});

